import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Text,
} from '@musa.tech/design-system';
import { useSinirLoginAnnouncement } from '@/hooks/useSinirLoginAnnouncement';
import {
  SINIR_INFO_URL,
  SINIR_SUPPORT_EMAIL,
  SINIR_SUPPORT_PHONE,
} from '@/config/sinirLoginAnnouncement';

export const SinirLoginAnnouncementModal = () => {
  const { shouldShow, onClose, onContactClick, contactError } = useSinirLoginAnnouncement();

  if (!shouldShow) return null;

  return (
    <Dialog open={shouldShow} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent
        aria-describedby="sinir-announcement-description"
        className="w-[calc(100vw-2rem)] max-w-[calc(100vw-2rem)] md:w-full md:max-w-[480px]"
      >
        <DialogHeader>
          <DialogTitle>
            Alteração de login no órgão emissor de MTR nacional Sinir
          </DialogTitle>
        </DialogHeader>
        <div id="sinir-announcement-description" className="space-y-4">
          <Text as="p" variant="body" className="text-neutral-700">
            A partir de agosto de 2026 o login precisa estar associado a uma conta Gov.br
            ativa de um usuário vinculado corretamente ao cadastro da empresa no Sinir. Se
            houver alguma alteração no seu cadastro, por favor informe o time Musa até o dia
            31 de julho.
          </Text>
          <Text as="p" variant="body">
            <a
              href={SINIR_INFO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline font-medium"
            >
              Para mais informações sobre a mudança, acesse o site do Sinir
            </a>
          </Text>
          {contactError && (
            <div className="w-full rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              Não foi possível abrir o chat. Entre em contato pelo telefone{' '}
              {SINIR_SUPPORT_PHONE} ou pelo e-mail {SINIR_SUPPORT_EMAIL}.
            </div>
          )}
        </div>
        <DialogFooter>
          <Button type="button" onClick={onContactClick} className="w-full md:w-auto">
            Entrar em contato
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
